import { render } from "./TimedNotifications.vue?vue&type=template&id=f5f2debe"
import script from "./TimedNotifications.vue?vue&type=script&lang=js"
export * from "./TimedNotifications.vue?vue&type=script&lang=js"

import "./TimedNotifications.vue?vue&type=style&index=0&id=f5f2debe&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TimedNotifications.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f5f2debe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f5f2debe', __exports__)) {
    api.reload('f5f2debe', __exports__)
  }
  
  module.hot.accept("./TimedNotifications.vue?vue&type=template&id=f5f2debe", () => {
    api.rerender('f5f2debe', render)
  })

}


export default __exports__